import React, { Fragment, Suspense } from 'react';
import { useForm, Controller } from "react-hook-form";
import { faFloppyDisk } from '@fortawesome/free-regular-svg-icons';
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import cx from "classnames";
import './assets/workflow.css';
import { getFormNameandLabel, populateFormDetails, prepareSearchConditionComponent, showToast } from '../../Common/Appcommon';
import Common from "../../Common/Common";
import CommonHeaderContent from '../../Common/CommonHeaderContent';
import SearchPanel from '../Search/SearchPanel';
import ActionList from './ActionList';
import requestApiService from '../../services/requestApi.service';
import { custom_filter_options, date_count_list, repeat_by_list, type_of_action_list, user_action_list, weekly_by_list, workflow_action_list } from '../Search/Constants';

class WorkFlowOperations extends React.Component {
    buttonClickRef = React.createRef();
    constructor(props) {
        super(props);
        let workflowId = props.match.params.id === undefined ? '' : props.match.params.id;
        this.state = {
            showLoader: false,
            formData: {},
            formList: [],
            selectedForm: [],
            selectedFormDetail: [],
            userActionList: [],
            selectedUserAction: [],
            matchAll: true,
            selectedActions: [],
            actions: [],
            actionCount: 1,
            workflowId: workflowId,
            searchComponents: [],
            removedActions: [],
            selectedRepeatBy: {},
            selectedDay: {},
            selectedMonthlyDate: {},
            autoTriggerConfig: {},
        }
        this.searchActionCB = false;
    }

    componentDidMount = async () => {
        this.setState({
            showLoader: true
        })
        await this.getFormNameList();
        await this.loadWorkflowActionData();
        this.setState({
            showLoader: false
        })

    }

    getFormNameList = async () => {

        let isEnabledList = {
            "isAddonEnabled": true,
            "isWsappEnabled": false,
            "isProfileEnabled": true,
            "type": "Workflow",
            "isContactRef": false,
            "isMenuEnabledOnly" : true,
        };
 
        let response = await getFormNameandLabel(isEnabledList);
        if (response.issuccess) {
            let data = response.data;
            this.setState({
                formList: data
            })
        }
    }

    onActionExecutionChange = (name, index, value) => {
        let { actions } = this.state;
        actions[index][name] = value;
        //alert(name+ "Actions : "+actions[index][name]);
        this.setState({ actions });
    }

    loadWorkflowActionData = async () => {
        let { workflowId } = this.state;
        let params = {
            "ENTITY": "NEW_WORKFLOW_ENTITY",
            "OPERATION": "GET_WORKFLOW_ACTIONS",
            "triggerid": workflowId
        }

        let res = await requestApiService.processServerRequest(params);
        if (res.issuccess) {
            let workFlowData = res.data;
            if (Object.keys(workFlowData[0]).length > 0) {
                await this.prepareWorkFlowEditAction(workFlowData);
            }
        }
    }

    prepareWorkFlowEditAction = async (workFlowData) => {
        if (workFlowData.length > 0) {
            let { formList } = this.state;
            let workflow = workFlowData[0];
            let triggerData = [];
            triggerData['workflow_name'] = workflow['workflow_name'];
            triggerData['workflow_description'] = workflow['workflow_description'];
            let formname = workflow['formname'];
            let onAction = workflow['onaction'];
            let actionNames = workflow['actionnames'];
            let conditiontxt = workflow['condition'];
            let actions = workflow['actions'] !== undefined ? workflow['actions'] : [];
            let autoTrigger = workflow['AUTOTRIGGER'];
            let selectedForm = [];
            let formDetail = [];
            for (let fl = 0; fl < formList.length; fl++) {
                let form = formList[fl];
                if (form.value === formname) {
                    selectedForm = form;
                    formDetail = await populateFormDetails(formname);
                    break;
                }
            }
            if (Object.keys(selectedForm).length) {
                let userActionList = await this.loadUserActionList(selectedForm.label);
                let selectedAction = [];
                for (let oa = 0; oa < userActionList.length; oa++) {
                    let actionList = userActionList[oa];
                    if (actionList.value === onAction) {
                        selectedAction = actionList;
                        break;
                    }
                }
                let selectedActions = {};
                for (let s = 0; s < actionNames.length; s++) {
                    let actionName = actionNames[s];
                    let actionTypeKey = type_of_action_list[actionName];
                    for (let sl = 0; sl < workflow_action_list.length; sl++) {
                        let a = workflow_action_list[sl];
                        if (actionTypeKey === a.value) {
                            let index = s;
                            let uniqueId = "action_type_" + index;
                            selectedActions[uniqueId] = a;
                            break;
                        }
                    }
                }
                let autoTriggerConfig = {};
                let selectedDay = {};
                let selectedMonthlyDate = {};
                let selectedRepeatBy = {};
                if (onAction === "Auto" && Object.keys(autoTrigger).length > 0) {
                    selectedRepeatBy = { value: autoTrigger['repeat_by'], label: autoTrigger['repeat_by'] };
                    if (selectedRepeatBy.value === "Weekly" && autoTrigger['weekly_day'] !== undefined) {
                        selectedDay = { value: autoTrigger['weekly_day'], label: autoTrigger['weekly_day'] };
                    } else if (selectedRepeatBy.value === "Monthly" && autoTrigger['monthly_date'] !== undefined) {
                        selectedMonthlyDate = { value: autoTrigger['monthly_date'], label: autoTrigger['monthly_date'] };
                    }
                    if (autoTrigger['timeValue'] !== undefined) {
                        autoTrigger['timeValue'] = dayjs(new Date(autoTrigger['timeValue']));
                        //alert(autoTrigger['timeValue']);
                    }
                    autoTriggerConfig = autoTrigger;

                }
                
                let new_actions = this.processActionVariableDefault(actions);

                this.setState({
                    formData: triggerData,
                    selectedForm: selectedForm,
                    userActionList: userActionList,
                    selectedUserAction: selectedAction,
                    selectedFormDetail: formDetail,
                    actions: new_actions,
                    actionCount: actions.length,
                    selectedActions: selectedActions,
                    autoTriggerConfig, selectedRepeatBy, selectedDay, selectedMonthlyDate
                })
            }
            if (conditiontxt !== "") {
                await this.prepareConditionComponents(conditiontxt, formDetail);
            }
        }
    }

    processActionVariableDefault = (actions) => {
        let new_actions = [];
        for(let i = 0; i < actions.length; i++) {
            let formInputData = actions[i];
            if(formInputData["typeofaction"] === "Send Whatsapp"){
                let components = formInputData['Components'];
                if(components && Object.keys(components).length > 0){
                    let header = components['header'];
                    formInputData['mediaUrl'] = header !== undefined && header['mediaUrl'] !== undefined ? header['mediaUrl'] : '';
                    let body = components['body'];
                    let variables = body['variables'];
                    for(let v = 0; v < variables.length; v++){
                        let variableSelect = variables[v];
                        let vIndex = variableSelect.parameter_name ? variableSelect.parameter_name : v + 1;
                        let tmpSelect = {
                            value : variableSelect.value,
                            label : variableSelect.label,
                            fieldType : variableSelect.fieldType
                        }
                        let objName = "body_variable_field_"+vIndex;
                        formInputData[objName+"_selected"] = this.props.resetAllCampVariables !== undefined && this.props.resetAllCampVariables ? {} : tmpSelect;
                        formInputData["body_df_value_field_"+vIndex] =  this.props.resetAllCampVariables !== undefined && this.props.resetAllCampVariables ? '' : variableSelect.defaultvalue;
                    }
                    let headerVariables = header !== undefined && header['variables'] !== undefined ? header['variables'] : {};
                    if(Object.keys(headerVariables).length > 0){
                        let tmpHeaderSelect = {
                            value : headerVariables.value,
                            label : headerVariables.label,
                            fieldType : headerVariables.fieldType
                        }
                        let objName = "header_variable_1";
                        formInputData[objName+"_selected"] = tmpHeaderSelect;
                        if(headerVariables.defaultvalue !== undefined && headerVariables.defaultvalue !== ""){
                            formInputData["header_df_value_field_1"] = headerVariables.defaultvalue;
                        }
                    }
                }
            }
            new_actions[i] = formInputData;
        }
        return new_actions;
    }
    
    prepareConditionComponents = async (conditiontxt, formDetail) => {
        let searchComponents = await prepareSearchConditionComponent(conditiontxt, formDetail);
        this.setState({
            searchComponents
        })
        /*let arr = conditiontxt.split("#");
        let fieldDetails = formDetail.length > 0 ? formDetail[1] : [];
        let fieldMapper = await this.getFieldNameandFDMapper(fieldDetails);
        let searchComponents = [];
        for (let a = 0; a < arr.length; a++) {
            let components = {};
            let condition = arr[a];
            if (condition === "") {
                continue;
            }
            condition = condition.replace("@ @", "");
            let condarr = condition.split("@");
            if (condarr.length == 6) {
                let isdate = condarr[0];
                let formName = condarr[1];
                let fieldName = isdate === "spl" ? condarr[1] : condarr[2];
                if (formName.split("_").length === 3) {
                    let fieldarr = formName.split("_");
                    fieldName = formName + "_table_" + fieldarr[1] + "_id";
                }
                let fd = fieldMapper[fieldName];
                if (fd === undefined || fd === null) {
                    continue;
                }
                components['fieldDetail'] = fd;
                components['errors'] = {};
                let changes = {};
                let conditions = {};
                if (isdate === "date") {
                    let operator = condarr[3];
                    changes['operator_0'] = operator;
                    let value = condarr[4];
                    if (operator == "Before" || operator == "After" || operator == "Below" || operator == "Above") {
                        let valarr = value.split("$");
                        changes['value_0'] = valarr[0];
                        changes['value_1'] = valarr[1];
                    } else if (operator == "Custom") {
                        let valarr = value.split("|");
                        changes["value_0"] = "";
                        changes["value_1"] = "";
                        changes['value_2'] = valarr[0];
                        changes['value_3'] = valarr[1];
                    } else if (value !== undefined) {
                        changes['value_2'] = value;
                        changes['value_2'] = value;
                    }
                } else if (isdate === "nondate") {
                    changes['operator_0'] = condarr[3];
                    changes['value_0'] = condarr[4];
                } else if (isdate === "spl") {
                    changes['operator_0'] = condarr[2];
                    changes['value_0'] = condarr[3];
                    changes['value_1'] = condarr[4];
                }
                conditions['condition_0'] = condarr[condarr.length - 1];
                components['changes'] = changes;
                components['condition'] = conditions;
            }
            searchComponents.push(components);
        }*/
        
    }

    saveWorkflowInfo = () => {
        this.buttonClickRef.current.click();
    }

    submitWorkFlowForm = async (e) => {
        e.preventDefault();
        let isValidSearch = await this.searchActionCB("validateInput");
        if (!isValidSearch) {
            let searchString = await this.searchActionCB("getSearchString", {
                modeOfSearch: this.state.matchAll ? "AND" : "OR",
            });
            if (searchString === "") {
                return;
            }
            //console.log(searchString);
            //return;
            let { actions, formData, selectedForm, selectedUserAction, workflowId, removedActions, autoTriggerConfig } = this.state;
            if (Object.keys(actions).length === 0) {
                showToast("Please configure atleast one valid action.");
                return;
            }
            let params = {
                "ENTITY": "NEW_WORKFLOW_ENTITY",
                "OPERATION": workflowId !== "" ? "EDIT" : "SAVE",
                "actions": actions,
                "workflow_name": formData["workflow_name"],
                "workflow_description": formData["workflow_description"] === undefined ? "" : formData["workflow_description"],
                "triggercond": searchString,
                "FORMNAME": selectedForm.value,
                "onAction": selectedUserAction.value,
                "AUTOTRIGGER": autoTriggerConfig,
                "workflowId": workflowId,
                "removedActions": removedActions,
            }
            let res = await requestApiService.processServerRequest(params, "WebV2", "post");
            if (res.issuccess) {
                showToast("Workflow saved successfully.");
                this.listWorkflows();
            }
        }
    }

    listWorkflows = async (e) => {
        window.location.href = "#/workflows";
    }

    systemActionSubmit = async (data, index) => {
        let { actions } = this.state;
        actions[index] = data;
        this.setState({ actions });
    }

    loadUserActionList = async (formLabel) => {
        let userActionList = [
            { value: "Add", label: "When a %FORMLABEL% is created" },
            { value: "Update", label: "When a %FORMLABEL% is updated" },
            { value: "Add/Update", label: "When a %FORMLABEL% is created or updated" },
            { value: "Auto", label: "Scheduled Events " }
        ];
        let uActionList = userActionList;
        for (let ual = 0; ual < uActionList.length; ual++) {
            let userAction = uActionList[ual];
            userAction.label = userAction.label.replace("%FORMLABEL%", formLabel);
            uActionList[ual] = userAction;
        }
        return uActionList;
    }

    handleTemplateChange = async (selectedValue, objName, uniqueId = "") => {
        let { formData, selectedActions, autoTriggerConfig } = this.state;
        if (selectedValue !== undefined && selectedValue !== null) {
            formData[objName] = selectedValue.value;
            if (objName === "selected_form") {
                let formDetail = await populateFormDetails(selectedValue.value);
                let formLabel = selectedValue.label;
                let userActionList = await this.loadUserActionList(formLabel);
                this.setState({
                    selectedForm: selectedValue,
                    selectedFormDetail: formDetail,
                    formData, userActionList,
                    selectedUserAction: []
                });
            } else if (objName === "on_useraction") {
                this.setState({
                    selectedUserAction: selectedValue,
                });
            } else if (objName === "action_change") {
                selectedActions[uniqueId] = selectedValue;
                this.setState({
                    selectedActions
                });
            } else if (objName === "repeat_by") {
                autoTriggerConfig[objName] = selectedValue.value;
                if (selectedValue.value !== "Mins" && selectedValue.value !== "Hours") {
                    let timeValue = dayjs(new Date());
                    autoTriggerConfig['timeValue'] = timeValue;
                }
                this.setState({
                    selectedRepeatBy: selectedValue,
                    autoTriggerConfig
                })
            } else if (objName === "weekly_day") {
                autoTriggerConfig[objName] = selectedValue.value;
                this.setState({
                    selectedDay: selectedValue, autoTriggerConfig
                })
            } else if (objName === "monthly_date") {
                autoTriggerConfig[objName] = selectedValue.value;
                this.setState({
                    selectedMonthlyDate: selectedValue, autoTriggerConfig
                })
            }
        }
    }

    handleChange = async (e) => {
        let name = e.target.name;
        let formInputData = this.state.formData;
        formInputData[name] = e.target.value;
        this.setState({
            formData: formInputData
        })
    }

    onTimeChange = async (timeValue, name) => {
        let autoTriggerConfig = this.state.autoTriggerConfig;
        autoTriggerConfig[name] = timeValue;
        this.setState({
            autoTriggerConfig
        })
    }

    searchClickCB = async (callback) => {
        this.searchActionCB = callback;
    }

    incrementActionCount = async () => {
        let actionCount = this.state.actionCount;
        actionCount = actionCount + 1;
        this.setState({
            actionCount
        })

    }

    decreaseActionCount = async (e, index) => {
        let { actionCount, actions, workflowId, removedActions, selectedActions } = this.state;
        if ((workflowId === "" && actionCount === 1) || actions[index] === undefined) {
            actionCount = actionCount - 1;
            this.setState({
                actionCount
            })
        } else {
            if(actions[index]['action_id'] !== undefined){
                removedActions.push(actions[index]['action_id']);
            }
            actions = actions.filter(
                (action, currentIndex) => currentIndex !== index
            );
            let selectedActions = {};
            for (let s = 0; s < actions.length; s++) {
                let action = actions[s];
                let actionName = action["typeofaction"];
                let actionTypeKey = type_of_action_list[actionName];
                for (let sl = 0; sl < workflow_action_list.length; sl++) {
                    let a = workflow_action_list[sl];
                    if (actionTypeKey === a.value) {
                        let index = s;
                        let uniqueId = "action_type_" + index;
                        selectedActions[uniqueId] = a;
                        break;
                    }
                }
            }
            actionCount = actions.length;
            this.setState({
                actions, actionCount, removedActions, selectedActions
            })
        }
    }


    render() {
        let {
            showLoader,
            formData,
            selectedFormDetail,
            userActionList,
            selectedUserAction,
            selectedActions,
            actionCount,
            actions,
            searchComponents,
            selectedRepeatBy,
            selectedDay,
            selectedMonthlyDate,
            autoTriggerConfig,
            workflowId
        } = this.state;
        let { controller } = this.props;
        const { register, handleSubmit: handleWorkFlowSubmit, control, formState: { errors } } = this.props.useForm;
        let actionsEle = [];
        if (selectedFormDetail.length > 0) {
            for (let ai = 0; ai < actionCount; ai++) {
                actionsEle.push(
                    <ActionList control={control}
                        errors={errors}
                        index={ai}
                        useForm={this.props.useForm}
                        onSelectChange={this.handleTemplateChange}
                        incrementActionCount={this.incrementActionCount}
                        decreaseActionCount={this.decreaseActionCount}
                        screenDetail={selectedFormDetail}
                        systemActionSubmit={this.systemActionSubmit}
                        actions={actions}
                        onActionExecutionChange={this.onActionExecutionChange}
                        isLast={ai == actionCount - 1}
                        aCount={actionCount}
                        selectedUserAction={selectedUserAction}
                        selectedActions={selectedActions} />)
            }
        }
        let buttonTxt = "Save & Close";
        let searchPanelComponent = <SearchPanel
            fieldDetails={selectedFormDetail[1]}
            onSearchClickRegister={this.searchClickCB}
            preSearchComponents={searchComponents}
            forceFilter={true}
            filterType={"trigger"}
            actionType={selectedUserAction.value === "Auto" ? "auto" : "user"}
        />;
        return (
            <Common pageTitle={"Workflows"} showLoader={showLoader} mainContent={
                <Fragment>
                    <CommonHeaderContent
                        addonButtons={[]}
                        buttonAction={this.saveWorkflowInfo}
                        headerTitle={"New Workflow"}
                        buttonIcon={faFloppyDisk}
                        buttonOutline={'success'}
                        buttonTxt={buttonTxt}
                        cancelBtn={true}
                        cancelURL={'workflows'}
                        mainContent={
                            <Fragment>
                                <div className={'workflow-panel'}>
                                    <Row>
                                        <Col md={'12'} className={''}>
                                            <div className="container">
                                                <form id="workflow-form" name={'workflow'}>
                                                    <div className={'mt-3 vertical-timeline-without-image'}>
                                                        <div className='automation-section'>
                                                            <div className={'group-header group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    1
                                                                </div>
                                                                <span> Name your Workflow</span>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='workflow-section__content'>
                                                                    <Col md="10" className={''}>
                                                                        <label className={'workflow-lbl form-label'} htmlFor="workflow_name">Name</label>
                                                                        <Controller
                                                                            name="workflow_name"
                                                                            control={control}
                                                                            rules={{ required: (this.state.formData.workflow_name === "" || this.state.formData.workflow_name === undefined) ? "Please provide a automation name" : false }}
                                                                            render={({ field }) => {
                                                                                return (
                                                                                    <input
                                                                                        {...field}
                                                                                        type="text"
                                                                                        name="workflow_name"
                                                                                        id="workflow-name"
                                                                                        value={formData.workflow_name}
                                                                                        autoComplete={"off"}
                                                                                        onChange={(e) => {
                                                                                            this.handleChange(e)
                                                                                            field.onChange(e);
                                                                                        }}
                                                                                        className={`form-control ${errors.workflow_name ? 'is-invalid' : ''}`}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        />
                                                                        {errors.workflow_name && <em className={`error invalid-feedback`}>{errors.workflow_name.message}</em>}
                                                                    </Col>
                                                                    <Col md="10" className={''}>
                                                                        <label className={'workflow-lbl form-label'} htmlFor="workflow_description">Description</label>
                                                                        <textarea value={formData.workflow_description} onChange={(e) => { this.handleChange(e) }} name={'workflow_description'} className={'form-control'} />

                                                                    </Col>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='automation-section'>
                                                            <div className={'group-header group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    2
                                                                </div>
                                                                <span> Choose a Module</span>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='workflow-section__content'>
                                                                    <div className={cx('')}>
                                                                        <Col md="10" >
                                                                            <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="selected_form">Choose a Module</label>
                                                                            <Controller
                                                                                name="selected_form"
                                                                                control={control}
                                                                                rules={{ required: Object.keys(this.state.selectedForm).length === 0 ? "Please choose a module" : false }}
                                                                                render={({ field }) => {
                                                                                    return (
                                                                                        <Select
                                                                                            {...field}
                                                                                            placeholder={'---Choose One---'}
                                                                                            menuPlacement={"auto"}
                                                                                            menuPosition={'fixed'}
                                                                                            name="selected_form"
                                                                                            id="selected_form"
                                                                                            className={`basic-multi-select ${errors.selected_form ? 'is-invalid' : ''}`}
                                                                                            classNamePrefix="wa-select"
                                                                                            value={Object.keys(this.state.formList).length === 0 ? false : this.state.selectedForm}
                                                                                            onChange={e => {
                                                                                                this.handleTemplateChange(e, 'selected_form');
                                                                                                field.onChange(e);
                                                                                            }}
                                                                                            isDisabled={workflowId !== ''}
                                                                                            options={this.state.formList}
                                                                                        />
                                                                                    );
                                                                                }}
                                                                            />
                                                                            {errors.selected_form && <em className={`error invalid-feedback`}>{errors.selected_form.message}</em>}
                                                                        </Col>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={cx('automation-section', { 'disabled': userActionList.length === 0 })}>
                                                            <div className={'group-header group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    3
                                                                </div>
                                                                <span> Set action type and trigger preference</span>
                                                            </div>
                                                            {userActionList.length > 0 &&
                                                                <div className='row'>
                                                                    <div className='workflow-section__content'>
                                                                        <div className={cx('')}>
                                                                            <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="on_useraction">Choose a Trigger</label>
                                                                            <Col md="10" >
                                                                                <Controller
                                                                                    name="on_useraction"
                                                                                    control={control}
                                                                                    rules={{ required: Object.keys(this.state.selectedUserAction).length === 0 ? "Choose" : false }}
                                                                                    render={({ field }) => {
                                                                                        return (
                                                                                            <Select
                                                                                                {...field}
                                                                                                placeholder={'---Choose One---'}
                                                                                                menuPlacement={"auto"}
                                                                                                menuPosition={'fixed'}
                                                                                                name="on_useraction"
                                                                                                id="on_useraction"
                                                                                                className={`basic-multi-select ${errors.on_useraction ? 'is-invalid' : ''}`}
                                                                                                classNamePrefix="wa-select"
                                                                                                value={Object.keys(userActionList).length === 0 ? false : selectedUserAction}
                                                                                                onChange={e => {
                                                                                                    this.handleTemplateChange(e, 'on_useraction');
                                                                                                    field.onChange(e);
                                                                                                }}
                                                                                                options={userActionList}
                                                                                            />
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                {errors.on_useraction && <em className={`error invalid-feedback`}>{errors.on_useraction.message}</em>}
                                                                            </Col>
                                                                        </div>
                                                                        {
                                                                            Object.keys(selectedUserAction).length > 0 && selectedUserAction.value === "Auto" &&
                                                                            <Col md="10" >
                                                                                <div className='d-flex-alone'>
                                                                                    <div className='col-md-2'>
                                                                                        <label className='workflow-lbl d-flex-alone form-label'>Repeat by </label>
                                                                                        <Controller
                                                                                            name="repeat_by"
                                                                                            control={control}
                                                                                            rules={{ required: Object.keys(selectedRepeatBy).length === 0 ? 'Please select repeat' : false }}
                                                                                            render={({ field }) => {
                                                                                                return (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        placeholder={'---Choose One---'}
                                                                                                        menuPlacement={"auto"}
                                                                                                        menuPosition={'fixed'}
                                                                                                        name="repeat_by"
                                                                                                        id="repeat_by"
                                                                                                        className={`basic-multi-select ${errors.repeat_by ? 'is-invalid' : ''}`}
                                                                                                        classNamePrefix="wa-select"
                                                                                                        value={selectedRepeatBy}
                                                                                                        onChange={e => {
                                                                                                            this.handleTemplateChange(e, 'repeat_by');
                                                                                                            field.onChange(e);
                                                                                                        }}
                                                                                                        options={repeat_by_list}
                                                                                                    />
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                        {errors.repeat_by && <em className={`error invalid-feedback`}>{errors.repeat_by.message}</em>}
                                                                                    </div>
                                                                                    {
                                                                                        Object.keys(selectedRepeatBy).length > 0 && selectedRepeatBy.value === "Hours" &&
                                                                                        <div className='d-flex-alone ml-1'>
                                                                                            <div className='col-md-3'>
                                                                                                <label className='workflow-lbl d-flex-alone form-label'>Every </label>
                                                                                                <Controller
                                                                                                    name="repeat_value"
                                                                                                    control={control}
                                                                                                    rules={{ required: (autoTriggerConfig.repeat_value === "" || autoTriggerConfig.repeat_value === undefined) ? "Enter value" : false }}
                                                                                                    render={({ field }) => {
                                                                                                        return (
                                                                                                            <input
                                                                                                                {...field}
                                                                                                                type="text"
                                                                                                                name="repeat_value"
                                                                                                                id="repeat_value"
                                                                                                                value={autoTriggerConfig.repeat_value}
                                                                                                                autoComplete={"off"}
                                                                                                                onChange={(e) => {
                                                                                                                    this.onTimeChange(e.target.value, e.target.name)
                                                                                                                    field.onChange(e);
                                                                                                                }}
                                                                                                                className={`form-control ${errors.repeat_value ? 'is-invalid' : ''}`}
                                                                                                            />
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                                {errors.repeat_value && <em className={`error invalid-feedback`}>{errors.repeat_value.message}</em>}
                                                                                            </div>
                                                                                            <label className='d-flex-end ml-1'>{selectedRepeatBy.label}</label>
                                                                                        </div>
                                                                                    }
                                                                                    {
                                                                                        Object.keys(selectedRepeatBy).length > 0 && (selectedRepeatBy.value === "Daily" || selectedRepeatBy.value === "Weekly" || selectedRepeatBy.value === "Monthly") &&
                                                                                        <div className='col-md-2 ml-1 repeat-config'>
                                                                                            <label className='workflow-lbl d-flex-alone form-dlabel'>At </label>
                                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                <TimePicker
                                                                                                    label=""
                                                                                                    value={autoTriggerConfig.timeValue === undefined ? dayjs(new Date()) : autoTriggerConfig.timeValue}
                                                                                                    onChange={(newValue) => this.onTimeChange(newValue, "timeValue")}
                                                                                                />
                                                                                            </LocalizationProvider>
                                                                                        </div>
                                                                                    }
                                                                                    {
                                                                                        Object.keys(selectedRepeatBy).length > 0 && selectedRepeatBy.value === "Weekly" &&
                                                                                        <div className='d-flex-alone ml-1 col-md-5'>
                                                                                            <div className='col-md-5'>
                                                                                                <label className='workflow-lbl d-flex-alone form-label'>Repeat for every week </label>
                                                                                                <Controller
                                                                                                    name="weekly_day"
                                                                                                    control={control}
                                                                                                    rules={{ required: Object.keys(selectedDay).length > 0 ? false : 'Please select value' }}
                                                                                                    render={({ field }) => {
                                                                                                        return (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                placeholder={'---Choose One---'}
                                                                                                                menuPlacement={"auto"}
                                                                                                                menuPosition={'fixed'}
                                                                                                                name="weekly_day"
                                                                                                                id="weekly_day"
                                                                                                                className={`basic-multi-select ${errors.weekly_day ? 'is-invalid' : ''}`}
                                                                                                                classNamePrefix="wa-select"
                                                                                                                value={selectedDay}
                                                                                                                onChange={e => {
                                                                                                                    this.handleTemplateChange(e, 'weekly_day');
                                                                                                                    field.onChange(e);
                                                                                                                }}
                                                                                                                options={weekly_by_list}
                                                                                                            />
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                                {errors.weekly_day && <em className={`error invalid-feedback`}>{errors.weekly_day.message}</em>}
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                    {
                                                                                        Object.keys(selectedRepeatBy).length > 0 && selectedRepeatBy.value === "Monthly" &&
                                                                                        <div className='d-flex-alone ml-1 col-md-6'>
                                                                                            <div className='col-md-2'>
                                                                                                <label className='workflow-lbl d-flex-alone form-label'>On the day </label>
                                                                                                <Controller
                                                                                                    name="monthly_date"
                                                                                                    control={control}
                                                                                                    rules={{ required: Object.keys(selectedMonthlyDate).length > 0 ? false : 'Please select value' }}
                                                                                                    render={({ field }) => {
                                                                                                        return (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                placeholder={'---Choose One---'}
                                                                                                                menuPlacement={"auto"}
                                                                                                                menuPosition={'fixed'}
                                                                                                                name="monthly_date"
                                                                                                                id="monthly_date"
                                                                                                                className={`basic-multi-select ${errors.monthly_date ? 'is-invalid' : ''}`}
                                                                                                                classNamePrefix="wa-select"
                                                                                                                value={selectedMonthlyDate}
                                                                                                                onChange={e => {
                                                                                                                    this.handleTemplateChange(e, 'monthly_date');
                                                                                                                    field.onChange(e);
                                                                                                                }}
                                                                                                                options={date_count_list}
                                                                                                            />
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                                {errors.monthly_date && <em className={`error invalid-feedback`}>{errors.monthly_date.message}</em>}
                                                                                            </div>
                                                                                            <label className='d-flex-end ml-1'>of every	months	</label>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </Col>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }

                                                        </div>
                                                        <div className={cx('automation-section', { 'disabled': selectedFormDetail.length === 0 || Object.keys(selectedUserAction).length === 0 })}>
                                                            <div className={'group-header group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    4
                                                                </div>
                                                                <span> Set condition to perform trigger action</span>
                                                            </div>
                                                            {selectedFormDetail.length > 0 && Object.keys(selectedUserAction).length > 0 &&
                                                                <div className='row'>
                                                                    <div className='workflow-section__content'>
                                                                        <label className={'workflow-lbl d-flex-alone form-label'}>Record matching certain conditions</label>
                                                                        <Col md="10" >
                                                                            {searchPanelComponent}
                                                                        </Col>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className={cx('automation-section', { 'disabled': selectedFormDetail.length === 0 || Object.keys(selectedUserAction).length === 0 })}>
                                                            <div className={'group-header group-header-flex'}>
                                                                <div className={'automation-stepnumber'}>
                                                                    5
                                                                </div>
                                                                <span>Set actions to preference</span>
                                                            </div>
                                                            {selectedFormDetail.length > 0 && Object.keys(selectedUserAction).length > 0 &&
                                                                <div className='row'>
                                                                    <div className='workflow-section__content'>
                                                                        <Col md="10" >
                                                                            {actionsEle}
                                                                        </Col>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className='workflow-form-footer card-footer hide'>
                                                            <a onClick={(e) => { this.listWorkflows(e) }} class="btn btn-outline-primary">Cancel</a>
                                                            <button ref={this.buttonClickRef} onClick={handleWorkFlowSubmit((data, event) => this.submitWorkFlowForm(event))} class="btn btn-outline-primary">Save & Activate</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Fragment>
                        }
                    />
                </Fragment>
            }
            />
        )
    }
}

export default WorkFlowOperations;